export const laoB = [
  [
    [113.67588360333824, 23.01683920526948, 10],
    [113.67590053658616, 23.016830234755044, 10],
  ],
  [
    [113.67583933766606, 23.01675674821597, 10],
    [113.6758579665269, 23.016751381278652, 10],
  ],
  [
    [113.67581609975515, 23.016667309825536, 10],
    [113.67583555076958, 23.01666590315206, 10],
  ],
  [
    [113.67581453313932, 23.01657518697403, 10],
    [113.67583380308623, 23.01657801284856, 10],
  ],
  [
    [113.67583134211402, 23.016485144983946, 10],
    [113.67585009067537, 23.01649014191737, 10],
  ],
  [
    [113.67586121055962, 23.016398085048223, 10],
    [113.6758790336124, 23.016405431487073, 10],
  ],
  [
    [113.6759045855294, 23.016315608762966, 10],
    [113.67592067588812, 23.016325822391003, 10],
  ],
  [
    [113.67595597889142, 23.016240115888124, 10],
    [113.67597313942684, 23.016248708232617, 10],
  ],
  [
    [113.6760073823285, 23.016162139788303, 10],
    [113.6760231836046, 23.016172733043618, 10],
  ],
  [
    [113.6760702242111, 23.016092051967977, 10],
    [113.67608459411623, 23.016104267528746, 10],
  ],
  [
    [113.67613481956674, 23.016024805616464, 10],
    [113.67614960616349, 23.016036587378352, 10],
  ],
  [
    [113.67619862238446, 23.01595619936547, 10],
    [113.67621308430762, 23.01596832150918, 10],
  ],
  [
    [113.67626456865658, 23.015889534734946, 10],
    [113.67627888449897, 23.0159018045436, 10],
  ],
  [
    [113.67633084521093, 23.015823277299397, 10],
    [113.67634516105238, 23.015835547102153, 10],
  ],
  [
    [113.67639729562234, 23.015757077761705, 10],
    [113.67641151206226, 23.015769446189125, 10],
  ],
  [
    [113.67646410470834, 23.015691280323555, 10],
    [113.6764783211658, 23.015703648727058, 10],
  ],
  [
    [113.67653091383568, 23.015625482757812, 10],
    [113.67654513029356, 23.01563785115425, 10],
  ],
  [
    [113.67659772280177, 23.01555968525225, 10],
    [113.67661193925771, 23.015572053643943, 10],
  ],
  [
    [113.67666453170246, 23.01549388771835, 10],
    [113.67667874815761, 23.015506256104157, 10],
  ],
  [
    [113.67673121462516, 23.015428142140063, 10],
    [113.67674560373165, 23.015440338248926, 10],
  ],
  [
    [113.67679875238069, 23.01536315602652, 10],
    [113.67681326458874, 23.015375226505082, 10],
  ],
  [
    [113.6768624814614, 23.01529547224846, 10],
    [113.6768776655965, 23.01530681240394, 10],
  ],
  [
    [113.6769176783994, 23.015222901956776, 10],
    [113.67693448034875, 23.015232081260606, 10],
  ],
  [
    [113.67696533055079, 23.015145732691167, 10],
    [113.67698342175245, 23.01515249386616, 10],
  ],
  [
    [113.67700897833149, 23.01506408775854, 10],
    [113.67702603947224, 23.015072847812586, 10],
  ],
  [
    [113.6770536550946, 23.014984480060928, 10],
    [113.67707124251453, 23.014992297599086, 10],
  ],
  [
    [113.67709500614585, 23.01490354525031, 10],
    [113.67711321254478, 23.01491003598987, 10],
  ],
  [
    [113.6771391562447, 23.014821419561013, 10],
    [113.6771555563122, 23.01483120175471, 10],
  ],
  [
    [113.67719526253394, 23.01474621519207, 10],
    [113.67721009964866, 23.014757942261017, 10],
  ],
  [
    [113.67726065068493, 23.014678958865623, 10],
    [113.67727514759548, 23.014691045010725, 10],
  ],
  [
    [113.67732719167337, 23.01461225738023, 10],
    [113.67734088115759, 23.014625124983624, 10],
  ],
  [
    [113.67739473169276, 23.014547913270942, 10],
    [113.67740924254282, 23.014559985060036, 10],
  ],
  [
    [113.67746171202677, 23.014481662062146, 10],
    [113.67747552678951, 23.014494414414116, 10],
  ],
  [
    [113.67753036801895, 23.01441760588582, 10],
    [113.67754428035461, 23.01443026701527, 10],
  ],
  [
    [113.67759847677775, 23.014353106428413, 10],
    [113.6776125453531, 23.01436561874752, 10],
  ],
  [
    [113.67766515257328, 23.01428747098151, 10],
    [113.67767950858752, 23.014299700340192, 10],
  ],
  [
    [113.67773150192548, 23.01422117339726, 10],
    [113.67774574548397, 23.01423351490603, 10],
  ],
  [
    [113.67779872202661, 23.014155409681052, 10],
    [113.67781260312236, 23.01416810013202, 10],
  ],
  [
    [113.67786730717036, 23.014091144906235, 10],
    [113.67788113106607, 23.01410388873888, 10],
  ],
  [
    [113.6779359569984, 23.014027341612376, 10],
    [113.67795015366227, 23.014039729313215, 10],
  ],
  [
    [113.67800219295108, 23.01396119834259, 10],
    [113.6780165299426, 23.013973446773857, 10],
  ],
  [
    [113.67807010960519, 23.013895888798363, 10],
    [113.67808387807514, 23.01390868392337, 10],
  ],
  [
    [113.67813820160666, 23.01383164035277, 10],
    [113.67815239785449, 23.013844028442442, 10],
  ],
  [
    [113.6782056428686, 23.01376611435604, 10],
    [113.6782195241952, 23.01377880455413, 10],
  ],
  [
    [113.67827392151958, 23.01370212804821, 10],
    [113.67828833815747, 23.013714296084128, 10],
  ],
  [
    [113.67833962834368, 23.013635211898887, 10],
    [113.67835385055452, 23.013647574425356, 10],
  ],
  [
    [113.6784068986876, 23.013569710921477, 10],
    [113.67842099375399, 23.01358219759123, 10],
  ],
  [
    [113.67847580483432, 23.013505482795228, 10],
    [113.67848954173547, 23.013518306926077, 10],
  ],
  [
    [113.67854627838976, 23.013442698861123, 10],
    [113.67855959870515, 23.013455894179618, 10],
  ],
  [
    [113.678617701613, 23.013380155425562, 10],
    [113.67862976643399, 23.01339434786246, 10],
  ],
  [
    [113.6786937410319, 23.0133236571454, 10],
    [113.67870586644833, 23.01333780526046, 10],
  ],
  [
    [113.67877174027082, 23.01326844929393, 10],
    [113.678782800705, 23.01328332636306, 10],
  ],
  [
    [113.67885321860828, 23.01321804786722, 10],
    [113.67886348876796, 23.013233402713247, 10],
  ],
  [
    [113.67893730178683, 23.013171595174963, 10],
    [113.67894690684187, 23.013187314533095, 10],
  ],
  [
    [113.67902469445653, 23.01313001269813, 10],
    [113.67903287859559, 23.013146406511673, 10],
  ],
  [
    [113.6791154813381, 23.0130970875789, 10],
    [113.67912288430104, 23.013113796574405, 10],
  ],
  [
    [113.67920561516017, 23.01306215703431, 10],
    [113.67921204943931, 23.013079206253416, 10],
  ],
  [
    [113.67929860719677, 23.01303416671782, 10],
    [113.67930450231488, 23.013051382173327, 10],
  ],
  [
    [113.67939249849165, 23.013009223175878, 10],
    [113.67939806437464, 23.013026532282503, 10],
  ],
  [
    [113.679486190904, 23.01298187376382, 10],
    [113.67949038741675, 23.012999510658517, 10],
  ],
  [
    [113.6795805612751, 23.0129613365084, 10],
    [113.67958584605653, 23.012978720947544, 10],
  ],
  [
    [113.67967467165532, 23.01293726415392, 10],
    [113.67967978046111, 23.012954693610187, 10],
  ],
  [
    [113.67976866298258, 23.012913329390127, 10],
    [113.67977389735147, 23.01293072689305, 10],
  ],
  [
    [113.67986208481852, 23.012888699886837, 10],
    [113.67986808229759, 23.012905885018892, 10],
  ],
  [
    [113.67995507176735, 23.012861140123114, 10],
    [113.67996089932582, 23.01287837527545, 10],
  ],
  [
    [113.68004809393004, 23.0128341998617, 10],
    [113.68005407164503, 23.01285139089272, 10],
  ],
  [
    [113.68013979182035, 23.01280485272861, 10],
    [113.68014668378925, 23.01282174797862, 10],
  ],
  [
    [113.68023069015659, 23.012772480517523, 10],
    [113.68023786767631, 23.01278927357964, 10],
  ],
  [
    [113.680321049654, 23.012739125784588, 10],
    [113.68032872143002, 23.012755730544058, 10],
  ],
  [
    [113.68041000963792, 23.01270270531998, 10],
    [113.68041816660256, 23.01271911072486, 10],
  ],
  [
    [113.6804984378629, 23.012664746176384, 10],
    [113.680506726585, 23.01268109489424, 10],
  ],
  [
    [113.68058622586773, 23.012626044803014, 10],
    [113.68059506970553, 23.012642142356203, 10],
  ],
  [
    [113.68067287874027, 23.01258506761803, 10],
    [113.68068215300423, 23.012600956257277, 10],
  ],
  [
    [113.68075718357584, 23.012540548773906, 10],
    [113.68076720255287, 23.012556045138673, 10],
  ],
  [
    [113.68084107633506, 23.012495146694505, 10],
    [113.68085145858757, 23.01251043678108, 10],
  ],
  [
    [113.68092276479354, 23.01244643435103, 10],
    [113.68093376182505, 23.012461351600372, 10],
  ],
  [
    [113.68100323164741, 23.012395462859956, 10],
    [113.68101430077297, 23.01241033434622, 10],
  ],
  [
    [113.68108200336086, 23.012343178369036, 10],
    [113.68109401963031, 23.012357405992763, 10],
  ],
  [
    [113.681158002627, 23.012287234353153, 10],
    [113.6811706742326, 23.01230096613738, 10],
  ],
  [
    [113.68123297069442, 23.012229257857264, 10],
    [113.68124541039901, 23.012243170142096, 10],
  ],
  [
    [113.6813075849116, 23.012171953114567, 10],
    [113.68132091620778, 23.01218513882275, 10],
  ],
  [
    [113.68138117042322, 23.012111764963407, 10],
    [113.68139343079537, 23.012125812988625, 10],
  ],
  [
    [113.68145628377607, 23.012054721586583, 10],
    [113.68146913799129, 23.012068307141533, 10],
  ],
  [
    [113.68152915111514, 23.011994875397768, 10],
    [113.68154219253942, 23.01200830719266, 10],
  ],
];
